module.exports = __webpack_public_path__ + "img/375_nav_img1.985a863d.png";